import { keyframes } from 'styled-components';

const bounce = keyframes`
0% {
  transform: scale(1);
}

33% {    
  transform: scale(0.75);
}

66% {    
  transform: scale(1.25);
}

100% {
  transform: scale(1);
}
`;

export { bounce };
//# sourceMappingURL=animations.js.map
